// Objects stored in Algolia

/* 
Date needs to be Unix timestamp for Algolia search to be able to filter/sort
https://www.algolia.com/doc/guides/sending-and-managing-data/prepare-your-data/in-depth/what-is-in-a-record/#dates 
*/

export interface SearchDoc {
  objectID: string // Mandatory Algolia field
  boost: number
  orgId: string
  type: SearchTypes
  title: string
  description: string
}

export enum SearchTypes {
  CreateAction = 'CreateAction',
  // « Nobody »: empties a picker that already holds someone (#108)
  ClearAction = 'ClearAction',
  PickCircle = 'PickCircle',
  Member = 'Member',
  Role = 'Role',
  Circle = 'Circle',
  Thread = 'Thread',
  Meeting = 'Meeting',
  Task = 'Task',
  Decision = 'Decision',
}

// What the search returns to the browser (CONF-02, phase 4): identifiers only,
// never the indexed text. The browser reads titles through Hasura.
export type SearchHit = Pick<SearchDoc, 'objectID' | 'type'>
